import React, {FunctionComponent, useState, useRef} from "react";
import { useEffect } from "react";
import {setIsLoading} from "@coveo/headless/dist/definitions/features/generated-answer/generated-answer-actions";

const NoResults: FunctionComponent<any> = (props) => {
  const [isLoading, setLoading] = useState(true);
  const [isShowNoResult, setIsShowNoResult] = useState(false);
  const isMounted = useRef(null);
  useEffect(() => {
    props.controller.subscribe(() => {
      if (isMounted.current) {
        //@ts-ignore
        setLoading(window.bypassCategoryNoresult || props.controller.state.isLoading || props.controller.state.searchResponseId == "");
      }
      //@ts-ignore
      let showNoResult = !window.bypassCategoryNoresult && !(props.controller.state.isLoading || props.controller.state.searchResponseId == "") && props.controller.state.results.length <= 0;
      // Get content configured from aem by element id coveo-no-result-container
      const appendNewElm = document.getElementById("coveo-no-result-content");
      if (appendNewElm) {
        const noResultElm = appendNewElm!.querySelector("#coveo-no-result-container");
        if (showNoResult) {
          if (noResultElm) {
          } else {
            const noResultElmXf = document.querySelector("#coveo-no-result #coveo-no-result-container");
            // Append content to the element id coveo-no-result-content on coveo
            if (noResultElmXf) {
              appendNewElm!.appendChild(noResultElmXf.cloneNode(true));
            }
          }
        }
      }
    });
  }, []);
  return  (
      <div id="coveo-no-result-content" ref={isMounted}>
        {isLoading && (
            <div className="loading-container search-loading">
              <div className="loading-spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
        )}
      </div>
  )
}

export default NoResults;
